var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1665 18.3333L7.93448 16.3717C7.07635 15.0054 6.64727 14.3222 5.96695 14.1994C4.85944 13.9994 3.71479 14.7537 2.9165 15.4241",
    stroke: "#FFAC06",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.9165 7.5V13.3566C2.9165 14.3589 2.9165 14.8601 3.16542 15.2628C3.41434 15.6656 3.8626 15.8898 4.75913 16.338L8.04602 17.9814C8.74667 18.3317 8.75342 18.3333 9.53675 18.3333H12.0832C14.4402 18.3333 15.6187 18.3333 16.3509 17.6011C17.0832 16.8688 17.0832 15.6903 17.0832 13.3333V7.5C17.0832 5.14297 17.0832 3.96447 16.3509 3.23223C15.6187 2.5 14.4402 2.5 12.0832 2.5H7.9165C5.55948 2.5 4.38097 2.5 3.64874 3.23223C2.9165 3.96447 2.9165 5.14297 2.9165 7.5Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99984 7.5H6.6665M13.3332 11.6667H6.6665",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 1.66663V3.33329M10.0002 1.66663V3.33329M5.8335 1.66663V3.33329",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.278fdede95610c639212a95d898b9eb0.svg";
export { ForwardRef as ReactComponent };